import apiClient from './axios';

export const getPlaylistPreferences = async () => {
    const response = await apiClient.get('/users/me/playlist-preferences/');
    return response.data;
};

export const upsertPlaylistPreference = async (songFileId, skip) => {
    const response = await apiClient.post('/users/me/playlist-preferences/', {
        song_file_id: songFileId,
        skip,
    });
    return response.data;
};

export const deletePlaylistPreference = async (songFileId) => {
    await apiClient.delete(`/users/me/playlist-preferences/${songFileId}`);
};
